import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { CountryService } from 'src/app/services/country.service';
import {MessageService} from 'primeng/api';
import { CommonService } from 'src/app/services/common.service';
import { Facebook } from '@ionic-native/facebook/ngx';
import { Capacitor } from '@capacitor/core';
import { localizedString } from '@angular/compiler/src/output/output_ast';

declare var webengage

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {
  mode="display" // display
  step=""
  isMarkAddress=false
  isMarkPhone=false
  isMarkDocument=false
  states:any=[]
  countries:any=[]
  mob_num
  typedNumber = ''
  typedOTP
  isMobileVerified=false
  date1: Date;
  yearRange: string = ''
  defaultDate: Date
  fi_name
  fi_logolink
  fi_disclaimer
  country_code
  gender = "--- Please select your gender ---"

  constructor(public auth:AuthService,public countryService:CountryService,public router:Router,public messageService:MessageService,public common:CommonService, public fb : Facebook) {
  }

  ngOnInit(): void {
    if(!this.auth.user.email_verified_at){
      this.router.navigateByUrl("/dashboard")
    }
    // console.log("AccountComponent ngOnInit called");
    this.setCountries();
    if(this.auth.user.mob_verified){
      this.mob_num=this.auth.user.mob_num
      this.isMobileVerified=true
    }

    if(!this.isUpdateble()){
      this.step="document"
      this.isMarkAddress=true
      this.isMarkPhone=true
      this.isMarkDocument=true
    }
    this.auth.user.country_id = 39
    // this.setStates(39)
    this.yearRange = (new Date().getFullYear() - 110) + ':' + (new Date().getFullYear() - 18)
    this.defaultDate = new Date(new Date().setFullYear(new Date().getFullYear() - 18))

    

  }

  setStates(country_id){
    // alert("FO")
    this.auth.user.country_id = +country_id
    this.common.showLoader()
    this.auth.getStates(+country_id).subscribe((res:any)=>{
      this.states=res.data.states
      //console.log(this.states)
      this.common.stopLoader()
    },err=>{
      //console.log(err)
      this.common.stopLoader()
    })
  }

  setCountries(){
    this.common.showLoader()
    this.countryService
    .getAll()
    .subscribe((res:any)=>{
      this.countries = res.data
      this.countries = [{
        "id": 39,
        "name": "Canada",
        "iso3": "CAN",
        "iso2": "CA",
        "phonecode": "1",
        "capital": "Ottawa",
        "currency": "CAD",
        "native": "Canada",
        "emoji": "🇨🇦",
        "emojiU": "U+1F1E8 U+1F1E6",
        "flag": 1,
        "wikiDataId": "Q16",
        "created_at": "2018-07-20T20:11:03.000000Z",
        "updated_at": "2020-05-16T10:49:11.000000Z"
      }]
      this.common.stopLoader()
    },err=>{
      this.common.stopLoader()
    })
  }

  sendOTP(){
    this.common.showLoader()
    this.auth.sendOTP({mob_num:+this.typedNumber, phone_code:this.country_code}).subscribe(res=>{
      if(res['return']){
        this.mob_num=this.typedNumber  
      }
      else{
        this.mob_num= ''
        this.typedNumber = ''
        this.messageService.add({severity: 'error', summary: 'Error', detail: 'Invalid mobile number'})
      }
      this.common.stopLoader()
    },err=>{
      let errorKeys = Object.keys(err.error.errors);
      errorKeys.forEach(key => {
        //console.log(key)
        let value = err.error.errors[key][0];
        this.messageService.add({severity:'error', summary:value, detail:""});
        //console.log(value);
    });
      //console.log(err)
      this.common.stopLoader()
    })
  }

  verifyOTP(){
    this.common.showLoader()
    this.auth.verifyOTP({otp:this.typedOTP,mob_num:this.mob_num,phone_code:this.country_code}).subscribe(res=>{
      //console.log(res)
      if(res['return'] ){
        // this.messageService.add({severity:'success', summary:'Successful', detail:res['message']});
        if(Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'ios'){
          this.fb.logEvent(this.fb.EVENTS.EVENT_NAME_COMPLETED_REGISTRATION,{
            Email : this.auth.user.email_id
          })
        }
        this.isMobileVerified=true
        
      }
      else{
        this.messageService.add({severity:'error', summary:res['message'], detail:""});
        //console.log(res)
      }
      this.common.stopLoader()
    },err=>{
      this.messageService.add({severity:'error', summary:'Incorrect OTP', detail:""  });
      //console.log(err)
      this.common.stopLoader()
    })
  }

  changeNumber(){
    this.mob_num=null
  }

  updateUser(updateUserForm){


    updateUserForm.value.email_id=this.auth.user.email
    updateUserForm.value.mob_num=this.mob_num
    updateUserForm.value.country=39
    if(this.auth.user.country_id==39){
      updateUserForm.value.country=parseInt(updateUserForm.value.country)
      updateUserForm.value.state=866
      updateUserForm.value.user_name=updateUserForm.value.name
      updateUserForm.value.p_email=updateUserForm.value.email_id
      let date = new Date(updateUserForm.value.dob)
      let dob = date.getDate()+'/'+ (+date.getMonth()+1) +'/'+date.getFullYear()
      updateUserForm.value.dob=dob
    }
    webengage.track("mobile_vefiication", {
      "Name" : updateUserForm.value.name,
      "Country" : updateUserForm.value.country,
      "State" : updateUserForm.value.state,
      "Phone" : this.mob_num,
    });
    //console.log(updateUserForm.value)
    this.common.showLoader()
    this.auth.updateUser(updateUserForm.value).subscribe(res=>{
      this.auth.setUser()
      if(this.auth.user.country_id == 233)
        this.step="document"
      else{
        this.router.navigateByUrl('/dashboard')
        // this.auth.setUser()
      } 
        
      webengage.track("kyc_status", {
        "Is_verified " : true,
        // "Country" : updateUserForm.value.country,
        // "State" : updateUserForm.value.state,
        // "Phone" : this.mob_num,
      });
      this.common.stopLoader()
    },err=>{
      let errorKeys = Object.keys(err.error.errors); 
      errorKeys.forEach(key => { 
        //console.log(key)
        let value = err.error.errors[key][0]; 
        this.messageService.add({severity:'error', summary:value, detail:""});
        //console.log(value); 
        this.common.stopLoader()

    }); 
      //console.log(err)

    })
  }

  isUpdateble(){
    if(this.auth.user.uuid && this.auth.user.country_id==233){
      return false
    }
    if(this.isMobileVerified && this.auth.user.country_id==39 && this.auth.user.state_id){
      return false
    }
    return true
  }

  goTo(step){
    if(step=='name'){
      this.isMarkAddress=false
      this.isMarkPhone=false
      this.isMarkDocument=false
    }
    if(step=='phone'){
      this.isMarkAddress=true
      this.isMarkDocument=false
      this.isMarkPhone=true
    }
    if(step=='address'){
      this.auth.user.country_id=39
      this.isMarkAddress=true
      this.isMarkPhone=false
      this.isMarkDocument=false
    }
    if(step=='document'){
      this.isMarkAddress=true
      this.isMarkPhone=true
      this.isMarkDocument=true
    }
    this.step=step
  }

  setDateRange(): string{
    this.yearRange = (new Date().getFullYear() - 110) + ':' + (new Date().getFullYear() - 18)
    return this.yearRange
  }
  get_fipartners(name){
    
    this.common.showLoader()
    this.auth.fipartners(name).subscribe((res:any)=>{
      //console.log(res)
      if(res.result || res.return){
        this.common.stopLoader()
        this.fi_name = res.data.fi_partner_details.name
        this.fi_logolink=res.data.fi_partner_details.logo
        this.fi_disclaimer=res.data.fi_partner_disclaimer
      }
      else{
        this.common.stopLoader()
      }
    }, err => {
      this.common.stopLoader()
    })
  }

  // cancelBtn(){
  //   this.router.navigateByUrl("/account")
  //   this.step.isMarkPurpose=false
  // }

/*   check(number){
    if(number.target.value.toString().length<=10 || number.keyCode==8){
      return true
    }
    else{
      return false
    }
  } */

}
